/**
 * Created by pskwira on 24.04.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../core/cookies', '../store/favouriteStore', 'tooltip', '../../utils'], function ($, _, EventEmitter, CookiesHelper, FavouriteStore, Tooltip, Utils) {

    var bookmarkConfig = {
        bookmarkPopupSelector: ".bookmark__popup",
        bookmarkPopupActiveClass: "bookmark__popup--visible",
        bookmarkUrlAttr: "bookmarkDataUrl"
    }

    var favouritesConfig = {
        favouritesTemplateTag: '.template.t__content',
        favouritesBoxSelector: ".favourites__box__container",
        favouritesTabsSelector: ".favourites__tabs__container",
        favouritesUrlAttr: "favouritesDataUrl",
        favouritesTabsContentSelector: ".favourites__tabs__content",
        favouritesTabsContentUrlAttr: "favouritesNodesUrl",
        favouritesTextSelector: ".favourites__text__container",
        favouritesSortingSelector: ".favourites__sorting-select",
        favouritesTabContentItems: ".tab__content__items",
        favouritesAddItemWrap: ".teaser__add-item-wrap"
    }

    var favouritesInitialObj = {
        header: {user: "", timestamp: "", is_saved: 0},
        general: {code: "", count: "", lang: ""},
        content: {products: [], pictures: [], patterns: []}
    }

    function Favourites() {
        var _this = this;

        window.addEventListener('updateFavouritesLocalStorage', function(){
            _this.favouritesObj = _this.favourtiesStore.getFavourites();
        });

        this.bindEvents();
    }

    Favourites.prototype = _.clone(EventEmitter.prototype);

    Favourites.prototype.init = function () {

        var _this = this;

        this.$bookmarkPopup = $(bookmarkConfig.bookmarkPopupSelector);
        this.$teaserActionElement = $('.favourites__action__wrapper');

        this.routeUrl = '';
        this.routeUrlWrite = this.routeUrl + '/favourites/write/';
        this.routeUrlRead = this.routeUrl + '/favourites/read/';

        this.favourtiesStore = new FavouriteStore();

        this.favouritesObj = favouritesInitialObj;

        if (CookiesHelper.getCookie('favourites')) {
            this.favouritesObj = this.favourtiesStore.getFavourites() ? this.verifyFavouritesStructure() : this.favourtiesStore.setFavourites(this.favouritesObj);
            this.matchSelected();
        } else {

            this.favouritesObj.header.lang = $('html').attr('data-fav-lang');
            this.favouritesObj.header.timestamp = Math.floor(Date.now()/ 1000);
            this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
            this.favouritesObj.general.lang = $('html').attr('lang');

            this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
            this.favouritesObj.general.lang = $('html').attr('lang');
            this.favouritesObj.general.code = "initial-code";

            CookiesHelper.setCookie('favourites', "initial-code", 100);

            this.favourtiesStore.setFavourites(this.favouritesObj);
        }

        setTimeout(function () {
            _this.loadFavouritesPageContent();
        }, 500);

        $(favouritesConfig.favouritesTabsSelector).on('change', favouritesConfig.favouritesSortingSelector + ' select', function (evt) {
            var sorting = evt.target.value;

            var $tabContent = $(this).closest(favouritesConfig.favouritesTabsContentSelector);
            var $itemWrap = $tabContent.find(favouritesConfig.favouritesTabContentItems);

            var $sortedItems = $itemWrap.children(':not(' + favouritesConfig.favouritesAddItemWrap + ')').sort((a, b) => {
                var valueA, valueB;

                if (sorting === 'date-added') {
                    valueA = parseInt(a.dataset.sorting);
                    valueB = parseInt(b.dataset.sorting);
                } else if (sorting === 'price-asc' || sorting === 'price-desc') {
                    var rangeA = $(a).find('.calculation__range').get(0);
                    valueA = rangeA ? parseInt(rangeA.innerText.match(/(\d+)/)[0]) : 99999;

                    var rangeB = $(b).find('.calculation__range').get(0);
                    valueB = rangeB ? parseInt(rangeB.innerText.match(/(\d+)/)[0]) : 99999;
                } else {
                    valueA = $(a).find('.teaser__content__header').text();
                    valueB = $(b).find('.teaser__content__header').text();
                }

                var result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
                return sorting.indexOf('-desc') > 0 ? result * -1 : result;
            });
            $itemWrap.prepend($sortedItems);
        });
    };

    Favourites.prototype.loadFavouritesPageContent = function () {

        var _this = this;

        var favouritesDataUrl = $(favouritesConfig.favouritesTabsSelector).attr('data-favourites-data-url');

        if ($('body').hasClass('page--favourites')) {
            _this.loadFavouritesPageData(favouritesDataUrl).then(function ($response) {
                _this.updateTemplateParts($response);
            });
        }

    };

    Favourites.prototype.loadTabsContent = function () {

        var _this = this;

        var items = $(favouritesConfig.favouritesTabsContentSelector);

        $.each(items, function (index, value) {

            var $item = $(value),
                nodetype = $item.attr('data-favourite-node-type'),
                itemId = $item.attr('data-favourite-tab-id'),
                itemItems = $item.attr('data-favourite-tab-items'),
                itemUrl = $item.attr('data-favourites-nodes-url');

            _this.loadFavouritesTabsNodes(itemUrl, nodetype, itemItems).then(function ($response) {

                var $currentTabcontent = $("[data-favourite-tab-id='" + itemId + "']");
                $currentTabcontent.html($($response).find(favouritesConfig.favouritesTabsContentSelector));

                _this.emit('favourites:tabscontent');  

                $(favouritesConfig.favouritesSortingSelector + ' select').trigger('change');

                $('.preloader--favourites-content').hide();

                if ( !!_this.favouritesObj.general.prices ) {
                    $("[data-favourites-prices]").show();
                }

                if ( !!_this.favouritesObj.general.many ) {
                    $("[data-favourites-asterisk]").show();
                }

            });

        });

    };

    Favourites.prototype.loadFavouritesTabsNodes = function (url, type, nodes) {

        return $.ajax({
            type: "POST",
            url: url,
            data: {"items": JSON.stringify({"type": type, "nodes": nodes})}
        }).done(function ($response) {
            return $response;
        });

    };

    Favourites.prototype.updateTemplateParts = function ($template) {

        $(favouritesConfig.favouritesTabsSelector).html($($template).find(favouritesConfig.favouritesTabsSelector));
        $(favouritesConfig.favouritesBoxSelector).html($($template).find(favouritesConfig.favouritesBoxSelector));
        $(favouritesConfig.favouritesTextSelector).html($($template).find(favouritesConfig.favouritesTextSelector));

        var bucket = $('div[data-favourite-bucket]').data('favourite-bucket');
        this.favourtiesStore.setFavourites(bucket);

        this.favouritesObj = bucket;

        this.emit('favourites:pagecontent');

        $('.preloader--favourites-page').hide();


    };

    Favourites.prototype.loadFavouritesPageData = function (url) {
        return $.get(url).then(function (response) {
            return response
        });
    };

    Favourites.prototype.bindEvents = function () {

        var _this = this;

        $(document).on({
            click: function (e) {
                var $button = $(this);
                if($button.attr('disabled')) return;

                disableButtonActionState($button, 'add');

                _this.processItem(e.currentTarget, 'new').then(function(){
                    disableButtonActionState($button, 'remove');
                });
            }
        }, '.favourites__action__assortment__item__new');

        $(document).on({
            click: function (e) {

                var $button = $(this);
                if($button.attr('disabled')) return;
                disableButtonActionState($button, 'add');
                _this.processItem(e.currentTarget, 'replace').then(function(){
                    disableButtonActionState($button, 'remove');
                });

            }
        }, '.favourites__action__assortment__item__replace');

        $(document).on({
            click: function (e) {

                e.stopImmediatePropagation();
                e.preventDefault();

                var $button = $(this);
                if($button.attr('disabled')) return;

                disableButtonActionState($button, 'add');

                _this.processItem(e.currentTarget, 'new').then(function(){
                    disableButtonActionState($button, 'remove');
                });

            }
        }, '.favourites__action__wrapper');

        $(document).on({
            click: function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                var $button = $(this);
                if($button.attr('disabled')) return;
                var item = $('#calculatorOverlay').find('.favourites__action__wrapper');

                disableButtonActionState($button, 'add');

                _this.processItem(item[0], 'new').then(function(){
                    disableButtonActionState($button, 'remove');
                });
            }
        }, '#addToFavouritesWithPrices');

        function disableButtonActionState($buttonReference, action){

            switch(action){
                case 'add':
                    $buttonReference.attr('disabled', 'disabled');
                    break;
                case 'remove':
                    $buttonReference.removeAttr('disabled');
                    break;
            }

        }

    };

    Favourites.prototype.generateCode = function () {

        var _this = this;

        $.ajax({
            type: "POST",
            url: _this.routeUrl + '/code/generate/',
            data: {}
        }).done(function (data) {
            if (data.status) {
                _this.favouritesObj.general.code = data.code;
                _this.favouritesObj.general.bookmark = window.location.origin + '/share/' + data.code;
                CookiesHelper.setCookie('favourites', _this.favouritesObj.general.code, 100);
            }
        });

    }

    Favourites.prototype.matchSelected = function (callbackAfterMatch) {
        var _this = this;
        var allitems = [];

        if ( this.favouritesObj !== undefined && this.favouritesObj.content !== undefined ) {
            allitems = allitems.concat(this.favouritesObj.content.products, this.favouritesObj.content.pictures, this.favouritesObj.content.patterns);
            allitems.forEach(function (element) {
                if (typeof element !== "undefined") {
                    if (typeof element.identifier !== "undefined") {
                        if(callbackAfterMatch) {
                            callbackAfterMatch(element.identifier)
                        } else {
                            _this.toggleSelectedClass(element.identifier)
                        }

                    }
                }
            });
        }

    };

    Favourites.prototype.addSelectedClass = function (identifier) {
        $('[data-fav-id="' + identifier + '"]').addClass('selected');
    };

    Favourites.prototype.toggleSelectedClass = function (identifier) {
        $('[data-fav-id="' + identifier + '"]').toggleClass('selected');
    };

    Favourites.prototype.extendFavItemByPriceData = function (obj, item) {

        var $item = $(item);

        if ($item.attr('data-fav-many-value')) {
            obj['many'] = ( $item.attr('data-fav-many-value') == 'true') ? true : false;
        }

        if ($item.attr('data-fav-qm-value')) {
            obj['qm'] = $item.attr('data-fav-price-value');
            obj['qmRange'] = $item.attr('data-fav-qm-value');
        }

        if ($item.attr('data-fav-price-value')) {
            obj['price'] = $item.attr('data-fav-price-value')
        }

        if ($item.attr('data-fav-calculation')) {
            obj['calculation'] = $item.attr('data-fav-calculation');
        }

    };

    Favourites.prototype.extendFavItemByParamsData = function (obj, item) {
        var $item = $(item);
        var selectedObject = {};
        var surfaceValue = $item.attr('data-fav-param-surface');
        var woodValue = $item.attr('data-fav-param-wood');
        var imageOverride = $item.attr('data-image-override');

        selectedObject['surface'] = surfaceValue ?  surfaceValue : '';
        selectedObject['wood'] = woodValue ? woodValue : '';

        if( imageOverride ) {
            selectedObject['image'] = imageOverride;
        }

        obj['selected'] = selectedObject;

    };

    Favourites.prototype.processFavouriteItem = function (item, action) {

        var $item = $(item);

        var nodeType = $item.data('fav-type');
        var nodeId = $item.data('fav-id');
        var externalUrl = $item.data('fav-url');
        var isPdf = $item.data('fav-pdf');
        var pdfPreview = $item.data('fav-pdf-preview');

        var surfaceValue = $item.attr('data-fav-param-surface') || '';
        var woodValue = $item.attr('data-fav-param-wood') || '';
        var productCombinationId = $item.attr('data-product-slug') || '';

        var imageOverride = $item.attr('data-image-override') || '';

        var arrayName = nodeType + 's'; //@todo: verifify table keys for 's'

        var array = this.favouritesObj.content[arrayName];

        if (!array) {
            array = [];

            var obj = externalUrl ?
                {identifier: externalUrl, url: externalUrl, type: nodeType, isPdf: isPdf, pdfPreview: pdfPreview} :
                {identifier: nodeId, type: nodeType, productCombinationId: productCombinationId};

            this.extendFavItemByParamsData(obj, item);
            this.extendFavItemByPriceData(obj, item);

            array.push(obj);

            window.tracking.trackGTM({
                'event': 'favourites',
                'action': 'add'
            });

            window.tracking.trackGA([
                'send',
                'event',
                'favourites',
                'add'
            ]);

        } else {

            var itemExist = false;
            var itemIndex = 0;

            if (action == 'replace') {

                array = _.filter(array, function (o) {
                    if (o.identifier != nodeId) return o;
                });

            } else {
                array.filter(function (item, index) {

                    if ( nodeType != 'pattern' ) {
                        if (item.identifier == nodeId &&
                            surfaceValue == item.selected.surface &&
                            woodValue == item.selected.wood) {
                            itemExist = true;
                            itemIndex = index;
                        } else {
                            if ( item.identifier == nodeId ) {
                                itemExist = true;
                                itemIndex = index;
                            }
                        }
                    } else {
                        if ( item.identifier == nodeId ) {
                            itemExist = true;
                            itemIndex = index;
                        }
                    }

                });
            }

            if (itemExist) {

                var obj = {identifier: nodeId, type: nodeType, productCombinationId: productCombinationId};

                this.extendFavItemByParamsData(obj, item);
                this.extendFavItemByPriceData(obj, item);

                if ($(item).attr('data-fav-page') || $(item).attr('data-fav-page-slug')) {
                    array.splice(itemIndex, 1);
                    array.push(obj);
                } else {
                    array.splice(itemIndex, 1);

                    window.tracking.trackGTM({
                        'event': 'favourites',
                        'action': 'remove'
                    });

                    window.tracking.trackGA([
                        'send',
                        'event',
                        'favourites',
                        'remove'
                    ]);

                }
            } else {
                if (externalUrl) {
                    array.push({
                        identifier: externalUrl,
                        url: externalUrl,
                        type: nodeType,
                        isPdf: isPdf,
                        pdfPreview: pdfPreview
                    });
                } else {

                    var obj = {identifier: nodeId, type: nodeType, productCombinationId: productCombinationId};
                    this.extendFavItemByParamsData(obj, item);
                    this.extendFavItemByPriceData(obj, item);

                    array.push(obj);
                }

                window.tracking.trackGTM({
                    'event': 'favourites',
                    'action': 'add'
                });

                window.tracking.trackGA([
                    'send',
                    'event',
                    'favourites',
                    'add'
                ]);

            }
        }

        this.toggleSelectedClass(nodeId);

        this.favouritesObj.content[arrayName] = array;

        var productsCount = ( this.favouritesObj.content.products != undefined ) ? this.favouritesObj.content.products.length : 0,
            picturesCount = ( this.favouritesObj.content.pictures != undefined ) ? this.favouritesObj.content.pictures.length : 0,
            patternsCount = ( this.favouritesObj.content.patterns != undefined ) ? this.favouritesObj.content.patterns.length : 0;

        this.favouritesObj.general.count = productsCount + picturesCount + patternsCount;
    };

    Favourites.prototype.processBookmarkUrl = function (oldCode, newCode) {
        // var url = this.$bookmarkPopup.attr("data-bookmark-data-url");
        //
        // if ( url ) {
        //     var urlArray = url.substring(url.indexOf('?') + 1).split('&');
        //     var urlToReplace = ( urlArray[0] == 'item=') ? url.replace('item=', 'item='+newCode ) : url.replace(oldCode, newCode )
        //     this.$bookmarkPopup.attr("data-bookmark-data-url", urlToReplace);
        // }
    };

    Favourites.prototype.removeFavourites = function (id, type, $element) {

        var _this = this;

        var $bookmarkItems = $('.favourites__tabs__container, .bookmark__popup').find("[data-fav-id='" + id + "']");

        $.each($bookmarkItems, function (index, value) {

            if (type == 'pattern') {

                if ($(value).parent().hasClass('teaser__pure--content')) {
                    $(value).closest('.col').remove();
                    var itemType = type;

                    var $tab = $("[data-tab-count-type=" + itemType + "]");

                    if ($tab.html() > 0) {
                        var count = $tab.html() - 1;
                        if (count >= 0) {
                            $tab.html(count)
                        }
                    }
                }

            } else {

                var $value = $(value);

                var surfaceValue = $value.attr('data-fav-param-surface') || '';
                var woodValue = $value.attr('data-fav-param-wood') || '';
                var surfaceValueFromElement = $element.attr('data-fav-param-surface') || '';
                var woodValueFromElement = $element.attr('data-fav-param-wood') || '';

                if(surfaceValue !== surfaceValueFromElement || woodValue !== woodValueFromElement){
                    return;
                }

                if ($(value).parent().hasClass('teaser__product')) {
                    $(value).closest('.col').remove();
                    var itemType = type;

                    var $tab = $("[data-tab-count-type=" + itemType + "]");
                    if ($tab.html() > 0) {
                        $tab.html($tab.html() - 1)
                    }
                }

            }
        });

        if ($('body').hasClass('hb180_bauwerk_documentfavourites')) {
            var $li = $("[data-tab-count-type=" + type + "]");
            var number = $li.html();

            if (number == 0) {

                $.each($('ul.tabs li.tab'), function (index, value) {

                    var el = $(value).find('span');
                    var id = el.attr('data-tab-count-type');
                    var count = el.html();

                    if (count > 0) {
                        $('ul.tabs').tabs('select_tab', id);
                        return;
                    }

                });

                $li.parent().hide();
            }

            if ( _this.favouritesObj.general.count == 0 ) {

                _this.favouritesObj.header.lang = $('html').attr('data-fav-lang');
                _this.favouritesObj.header.timestamp = Math.floor(Date.now()/ 1000);
                _this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
                _this.favouritesObj.general.lang = $('html').attr('lang');

                _this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
                _this.favouritesObj.general.lang = $('html').attr('lang');
                _this.favouritesObj.general.code = "initial-code";

                CookiesHelper.setCookie('favourites', "initial-code", 100);

                _this.loadFavouritesPageContent();

            }
        }
    };

    Favourites.prototype.searchItem = function (item) {

        var nodeType = $(item).data('fav-type');
        var nodeId = $(item).data('fav-id');

        var array = this.favouritesObj.content['products'];

        var itemExist = false;
        var itemIndex = 0;

        array.filter(function (item, index) {

            if (item.identifier == nodeId) {
                itemExist = true;
                itemIndex = index;
            }

        });

        return ( !!itemExist ) ? true : false;

    };

    Favourites.prototype.processItem = function (element, action) {

        var _this = this;
        var processItemPromise = Utils.createPromise();

        $.ajax({
            type: "POST",
            url: _this.routeUrl + '/code/generate/',
            data: {}
        }).done(function (data) {

            if (data.status) {

                CookiesHelper.setCookie('favourites', data.code, 100);

                if (_this.favouritesObj === undefined) {
                    _this.favouritesObj = _this.favourtiesStore.getFavourites();
                }

                _this.processBookmarkUrl(_this.favouritesObj.general.code, data.code);

                _this.favouritesObj.header.lang = $('html').attr('data-fav-lang');
                _this.favouritesObj.header.timestamp = Math.floor(Date.now()/ 1000);
                _this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
                _this.favouritesObj.general.lang = $('html').attr('lang');
                _this.favouritesObj.general.code = data.code;
                _this.favouritesObj.general.bookmark = window.location.origin + '/share/' + data.code;

                _this.processFavouriteItem(element, action);

                var url = $(element).attr('data-url');


                $.ajax({
                    type: "POST",
                    url: _this.routeUrl + '/favourites/write/',
                    data: {"fav": JSON.stringify(_this.favouritesObj)}
                }).done(function (data) {
                    if (element && element.hasAttribute('data-fav-action-delete')) {
                        _this.emit('favourites:remove', $(element).attr('data-fav-id'), $(element).attr('data-fav-type'), _this.favouritesObj, $(element));
                    } else {
                        _this.emit('favourites:set', _this.favouritesObj);
                    }

                    processItemPromise.resolve();

                });



            }
        });

        return processItemPromise.promise();

    };

    Favourites.prototype.updateFavourites = function () {

        var _this = this;

        $.ajax({
            type: "POST",
            url: _this.routeUrl + '/code/generate/',
            data: {}
        }).done(function (data) {

            if (data.status) {

                _this.processBookmarkUrl(_this.favouritesObj.general.code, data.code);

                _this.favouritesObj = _this.favourtiesStore.getFavourites();
                _this.favouritesObj.general.code = data.code;
                _this.favouritesObj.general.bookmark = window.location.origin + '/share/' + data.code;

                CookiesHelper.setCookie('favourites', data.code, 100);

                $.ajax({

                    type: "POST",
                    url: _this.routeUrl + '/favourites/write/',
                    data: {"fav": JSON.stringify(_this.favouritesObj)}

                }).done(function (data) {

                    _this.emit('favourites:set', _this.favouritesObj);
                    _this.loadTabsContent();
                });

            }
        })
    };

    Favourites.prototype.verifyFavouritesStructure = function () {

        /* search for old structure in patterns  */

        var _this = this;
        var anyChange = false;
        var favourites = _this.favourtiesStore.getFavourites();
        var items = 0;

        // if ( favourites['content']['products'].length > 0 ){
        //
        //     var products = favourites['content']['products'];
        //     products.forEach(function (element, index) {
        //
        //         if ( element['productCombinationId'] == '' ) {
        //             favourites['content']['products'].splice(index, 1);
        //             anyChange = true;
        //             items++;
        //         }
        //
        //     });
        //
        // }

        if ( favourites['content']['patterns'].length > 0 ){
            /* searcgh for old structure in patterns  */
            var patterns = favourites['content']['patterns'];
            patterns.forEach(function (element, index) {

                var musterExist = 'muster' in element;
                var collectionExist = 'collection' in element;

                if ( !musterExist && !collectionExist ) {
                    favourites['content']['patterns'].splice(index, 1);
                    anyChange = true;
                    items++;
                }

            });
        }

        if ( anyChange ) {

            favourites['general']['count'] = ( favourites['general']['count'] > 0 ) ? favourites['general']['count']-items : 0;

            if ( favourites['general']['count'] == 0 ) {

                _this.favouritesObj.header.lang = $('html').attr('data-fav-lang');
                _this.favouritesObj.header.timestamp = Math.floor(Date.now()/ 1000);
                _this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
                _this.favouritesObj.general.lang = $('html').attr('lang');

                _this.favouritesObj.header.user = CookiesHelper.getCookie('uid');
                _this.favouritesObj.general.lang = $('html').attr('lang');
                _this.favouritesObj.general.code = "initial-code";

                CookiesHelper.setCookie('favourites', "initial-code", 100);

                _this.favourtiesStore.setFavourites(this.favouritesObj);

            } else {

                var processItemPromise = Utils.createPromise();

                $.ajax({
                    type: "POST",
                    url: _this.routeUrl + '/code/generate/',
                    data: {}
                }).done(function (data) {

                    favourites['general']['code'] = data.code

                    CookiesHelper.setCookie('favourites', favourites['general']['code'], 100);

                    $.ajax({
                        type: "POST",
                        url: _this.routeUrl + '/favourites/write/',
                        data: {"fav": JSON.stringify(favourites)}
                    }).done(function (data) {
                        _this.emit('favourites:set', favourites);
                        processItemPromise.resolve();
                    });

                });

                anyChange = false;

            }

        }


        return this.favourtiesStore.getFavourites();

    }

    Favourites.prototype.postCalulationUpdateFavourites = function () {

        var _this = this;

        $('.tab__content').remove();

        $('.preloader--favourites-content').show();


        _this.updateFavourites();
    };

    Favourites.prototype.updateCurrentBucketFavouritesStorage = function () {

        var _this = this;

        var bookmarkItems = _this.$bookmarkPopup.find('[data-node-to-remove]');

        if ( bookmarkItems.length == 0 ) return;

        var allItemsToRemove = [];

        $.each(bookmarkItems, function (index, value) {
            var identifier = $(value).data('bookmarkItemId');
            if ( identifier ) {
                allItemsToRemove.push(identifier);
            }
        });
        if ( _this.favouritesObj['content']['products'].length > 0 ) {
            _this.favouritesObj['content']['products'].filter(function(element, index, array) {
                if ( allItemsToRemove.indexOf(element.identifier) != -1 ) {
                    _this.favouritesObj['content']['products'].splice(index, 1);
                }
            });
        }

        _this.favourtiesStore.setFavourites(_this.favouritesObj);

    };

    return Favourites;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/favourites/favourites.js